
<template>
  <!-- 监控数据展示组件 -->
  <div :class="['monitor-container', `theme-${currentTheme}`]">
    <!-- 页面标题区域 -->
    <div class="page-header">
      <h1 class="page-title">作品详细数据监控系统</h1>
      <p class="page-subtitle">实时监控视频详细数据，掌握内容传播趋势</p>
    </div>

    <!-- 主要内容容器 -->
    <div class="main-content">
      <!-- Tab切换区域 -->
      <div class="tab-container">
        <div class="tab-nav">

          <button
              v-for="tab in tabs"
              :key="tab.name"
              :class="['tab-btn', { 'active': activeTab === tab.name }]"
              @click="activeTab = tab.name"
          >
            {{ tab.label }}
          </button>
        </div>

        <!-- 修改Tab内容区域 -->
        <div class="tab-content">
          <!-- 监控Tab内容 -->
          <div v-show="activeTab === 'monitor'"
               :class="{ 'tab-pane': true, 'active': activeTab === 'monitor'
          }">
            <!-- 监控配置区域 -->
            <div class="monitor-config">
              <!-- 修改视频链接输入框部分的模板 -->
              <div class="input-group">
                <div class="url-input-container">
                  <input
                      v-model="videoUrl"
                      type="text"
                      placeholder="请输入作品视频分享链接（支持短链和长链）"
                      @keyup.enter="queryVideo"
                      class="url-input"
                  />
                  <!-- 添加清空按钮 -->
                  <button
                      v-if="videoUrl"
                      @click="clearVideoUrl"
                      class="clear-btn"
                      title="清空"
                  >
                    ×清空
                  </button>
                </div>

                <button
                    @click="queryVideo"
                    class="submit-btn"
                    :disabled="isQuerying"
                >
                  {{ isQuerying ? '查询中...' : '查询' }}
                </button>

                <button
                    @click="startMonitoring"
                    class="submit-btn"
                    :disabled="!isDataQueried"
                >
                  开始监控
                </button>
              </div>


              <!-- 在监控配置区域后添加 -->
              <div v-if="videoInfo" class="video-info-section">
                <h3>视频信息</h3>
                <div class="video-info-content">
                  <div class="video-basic-info">
                    <div class="avatar-section">
                      <img :src="videoInfo.aweme_cover" :alt="videoInfo.author_nickname" class="author-avatar">
                      <div class="author-info">
                        <p class="author-nickname">{{ videoInfo.author_nickname }}</p>
                        <p class="author-id">@{{ videoInfo.author_unique_id }}</p>
<!--                        <p class="author-id">@{{ videoInfo.desc }}</p>-->
                      </div>
                    </div>

                  </div>
                  <div class="video-desc">
                    <p class="video-description">视频id：{{ videoInfo.aweme_id }}</p>
                    <p class="video-description">{{ videoInfo.desc }}</p>
                    <p class="video-time">发布时间: {{ videoInfo.publish_time }}</p>
                  </div>
                </div>
              </div>



              <!-- 监控时长选择 -->
              <div class="duration-options">
                <label class="duration-label">监控时长：</label>
                <div class="radio-group" :class="{ 'disabled': !isDataQueried }">
                  <label
                      v-for="duration in durations"
                      :key="duration.value"
                      class="radio-option"
                  >
                    <input
                        type="radio"
                        v-model="selectedDuration"
                        :value="duration.value"
                        name="duration"
                        class="radio-input"
                        @change="handleDurationChange"
                    />
                    <span class="radio-text">{{ duration.label }}</span>
                  </label>
                </div>
              </div>


              <!-- 使用教程 -->
              <div class="usage-guide">
                <h3>使用教程</h3>
                <ul>
                  <li>在上方输入框中粘贴视频链接</li>
                  <li>点击"查询"按钮获取视频详细信息</li>
                  <li>选择需要监控的天数</li>
                  <li>点击"开始监控"按钮创建监控任务</li>
                  <li>在"监控中"或"监控结束"标签页查看监控数据和图表</li>
                </ul>
              </div>




            </div>
          </div>


          <!-- 监控中Tab内容 -->
          <div v-show="activeTab === 'monitoring'" :class="{ 'tab-pane': true, 'active': activeTab === 'monitoring' }">

            <div class="input-group">
            <!-- 添加搜索框 -->
            <div class="search-container">
              <input
                  v-model="searchQuery"
                  placeholder="搜索任务ID、视频ID或标题..."
                  class="search-input"
                  @keyup.enter="handleSearch"
              />
              <button @click="clearSearch" class="clear-btn-search" v-if="searchQuery">×清空</button>
            </div>
              <button @click="handleSearch" class="submit-btn-search">搜索</button>
            </div>


            <!-- 任务汇总信息 -->
            <div class="task-summary">
              <p>总共有 {{ pagination.total }} 个监控任务</p>
            </div>

            <!-- 任务列表容器 -->
            <div class="task-list-container" @scroll="handleScroll">
              <div v-if="tasks.length === 0 && !pagination.loading" class="no-tasks">
                <p>暂无监控任务</p>
              </div>

              <div v-else>
                <div class="task-item" v-for="(task, index) in tasks" :key="task.task_id">
                  <!-- 视频信息展示 -->
                  <div class="video-info">
                    <img :src="task.content_image" alt="视频封面" class="video-cover">
                    <div class="video-details">
                      <p class="video-desc">任务id: {{ task.task_id }}</p>
                      <p class="video-desc">视频id: {{ task.content_id }}</p>
                      <p class="video-desc">{{ task.content_title }}</p>
                      <p class="video-time">发布时间: {{ task.publish_time }}</p>
                      <p class="monitor-period">监控周期: {{ task.start_time }} ~ {{ task.end_time }}</p>
                      <p class="monitor-period">监控天数: {{ task.monitor_duration }}</p>
                    </div>
                  </div>

                  <!-- 操作按钮 -->
                  <div class="action-buttons">
                    <button @click="viewChart(task)" class="btn-view">查看图表</button>
                    <button @click="viewMonitoringTable(task)" class="btn-view-table">查看表格</button>
                    <button @click="confirmDeleteTask(task)" class="btn-delete">删除</button>
                  </div>
                </div>

                <!-- 加载更多提示 -->
                <div v-if="pagination.loading" class="loading-more">
                  <p>加载中...</p>
                </div>

                <!-- 没有更多数据提示 -->
                <div v-else-if="!pagination.hasMore && tasks.length > 0" class="no-more-data">
                  <p>没有更多数据了</p>
                </div>
              </div>
            </div>

            <!-- 图表弹窗 -->
            <div v-if="currentViewTask" class="chart-modal">
              <div class="modal-content">
                <div class="modal-header">
                  <h3>{{ currentViewTask.content_title }}</h3>
                  <h3>视频id:{{ currentViewTask.content_id }}</h3>
                  <h3>任务id:{{ currentViewTask.task_id }}</h3>
                  <button @click="closeChartModal" class="close-btn">×</button>
                </div>
                <div class="chart-container">
                  <canvas ref="chartCanvas" id="monitor-chart"></canvas>
                </div>
                <div class="data-status">
                  <span>最后更新: 2026-04-30 12:00:00</span>
                </div>
              </div>
            </div>

            <!-- 监控中任务表格弹窗 -->
            <div v-if="showMonitoringTableModal" class="table-modal">
              <div class="modal-content table-modal-content">
                <div class="modal-header">
                  <h3>{{ currentMonitoringTableTask.content_title }}</h3>
                  <h3>视频id:{{ currentMonitoringTableTask.content_id }}</h3>
                  <h3>任务id:{{ currentMonitoringTableTask.task_id }}</h3>
                  <button @click="closeMonitoringTableModal" class="close-btn">×</button>
                </div>
                <div class="table-container">
                  <table class="monitor-data-table">
                    <thead>
                      <tr>
                        <th>作品链接</th>
                        <th>日期</th>
                        <th>播放量</th>
                        <th>点赞量</th>
                        <th>评论量</th>
                        <th>分享量</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in monitoringTableData" :key="index">
                        <td class="video-link-cell">
                          <a :href="`https://www.douyin.com/video/${currentMonitoringTableTask.content_id}`" target="_blank" class="video-link">
                            https://www.douyin.com/video/{{ currentMonitoringTableTask.content_id }}
                          </a>
                        </td>
                        <td>{{ row.date }}</td>
                        <td>{{ row.play_count }}</td>
                        <td>{{ row.like_count }}</td>
                        <td>{{ row.comment_count }}</td>
                        <td>{{ row.share_count }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="table-footer">
                  <button @click="exportMonitoringTableToExcel" class="btn-export-excel">导出Excel</button>
                  <span class="data-status-text">最后更新: 2026-04-30 12:00:00</span>
                </div>
              </div>
            </div>

            <!-- 删除确认弹窗 -->
            <div v-if="deleteConfirm" class="confirm-modal">
              <div class="modal-content">
                <h3>确认删除</h3>
                <p>确定要删除此监控任务吗？这将同时删除所有相关数据。</p>
                <div class="modal-footer">
                  <button @click="cancelDelete" class="btn-cancel">取消</button>
                  <button @click="confirmDelete" class="btn-confirm">确定</button>
                </div>
              </div>
            </div>
          </div>



          <!-- 监控结束Tab内容 -->
          <div v-show="activeTab === 'finished'" :class="{ 'tab-pane': true, 'active': activeTab === 'finished' }">



            <div class="input-group">
              <!-- 添加搜索框 -->
              <div class="search-container">
                <input
                    v-model="finishedSearchQuery"
                    placeholder="搜索任务ID、视频ID或标题..."
                    class="search-input"
                    @keyup.enter="handleFinishedSearch"
                />
                <button @click="clearFinishedSearch" class="clear-btn-search" v-if="finishedSearchQuery">×清空</button>
              </div>
              <button @click="handleFinishedSearch" class="submit-btn-search">搜索</button>
            </div>

            <!-- 监控结束任务汇总信息 -->
            <div class="task-summary">
              <p>总共有 {{ finishedPagination.total }} 个监控结束任务</p>
            </div>

            <!-- 监控结束任务列表容器 -->
            <div class="task-list-container" @scroll="handleFinishedScroll">
              <div v-if="finishedTasks.length === 0 && !finishedPagination.loading" class="no-tasks">
                <p>暂无监控结束任务</p>
              </div>

              <div v-else>
                <div class="task-item" v-for="(task, index) in finishedTasks" :key="task.task_id">
                  <!-- 视频信息展示 -->
                  <div class="video-info">
                    <img :src="task.content_image" alt="视频封面" class="video-cover">
                    <div class="video-details">
                      <p class="video-desc">任务id: {{ task.task_id }}</p>
                      <p class="video-desc">视频id: {{ task.content_id }}</p>
                      <p class="video-desc">{{ task.content_title }}</p>
                      <p class="video-time">发布时间: {{ task.publish_time }}</p>
                      <p class="monitor-period">监控周期: {{ task.start_time }} ~ {{ task.end_time }}</p>
                      <p class="monitor-period">监控天数: {{ task.monitor_duration }}</p>
                    </div>
                  </div>

                  <!-- 操作按钮 -->
                  <div class="action-buttons">
                    <button @click="viewFinishedChart(task)" class="btn-view">查看图表</button>
                    <button @click="viewFinishedTable(task)" class="btn-view-table">查看表格</button>
                    <button @click="confirmDeleteTask(task)" class="btn-delete">删除</button>
                  </div>
                </div>

                <!-- 加载更多提示 -->
                <div v-if="finishedPagination.loading" class="loading-more">
                  <p>加载中...</p>
                </div>

                <!-- 没有更多数据提示 -->
                <div v-else-if="!finishedPagination.hasMore && finishedTasks.length > 0" class="no-more-data">
                  <p>没有更多数据了</p>
                </div>
              </div>
            </div>

            <!-- 监控结束任务图表弹窗 -->
            <div v-if="currentFinishedViewTask" class="chart-modal">
              <div class="modal-content">
                <div class="modal-header">
                  <h3>{{ currentFinishedViewTask.content_title }}</h3>
                  <h3>视频id:{{ currentFinishedViewTask.content_id }}</h3>
                  <h3>任务id:{{ currentFinishedViewTask.task_id }}</h3>
                  <button @click="closeFinishedChartModal" class="close-btn">×</button>
                </div>
                <div class="chart-container">
                  <canvas ref="finishedChartCanvas" id="finished-monitor-chart"></canvas>
                </div>
                <div class="data-status">
                  <span>最后更新: 2026-04-30 12:00:00</span>
                </div>
              </div>
            </div>

            <!-- 监控结束任务表格弹窗 -->
            <div v-if="showFinishedTableModal" class="table-modal">
              <div class="modal-content table-modal-content">
                <div class="modal-header">
                  <h3>{{ currentFinishedTableTask.content_title }}</h3>
                  <h3>视频id:{{ currentFinishedTableTask.content_id }}</h3>
                  <h3>任务id:{{ currentFinishedTableTask.task_id }}</h3>
                  <button @click="closeFinishedTableModal" class="close-btn">×</button>
                </div>
                <div class="table-container">
                  <table class="monitor-data-table">
                    <thead>
                      <tr>
                        <th>作品链接</th>
                        <th>日期</th>
                        <th>播放量</th>
                        <th>点赞量</th>
                        <th>评论量</th>
                        <th>分享量</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in finishedTableData" :key="index">
                        <td class="video-link-cell">
                          <a :href="`https://www.douyin.com/video/${currentFinishedTableTask.content_id}`" target="_blank" class="video-link">
                            https://www.douyin.com/video/{{ currentFinishedTableTask.content_id }}
                          </a>
                        </td>
                        <td>{{ row.date }}</td>
                        <td>{{ row.play_count }}</td>
                        <td>{{ row.like_count }}</td>
                        <td>{{ row.comment_count }}</td>
                        <td>{{ row.share_count }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="table-footer">
                  <button @click="exportToExcel" class="btn-export-excel">导出Excel</button>
                  <span class="data-status-text">最后更新: 2026-04-30 12:00:00</span>
                </div>
              </div>
            </div>

            <!-- 删除确认弹窗（复用原有的） -->
            <div v-if="deleteConfirm" class="confirm-modal">
              <div class="modal-content">
                <h3>确认删除</h3>
                <p>确定要删除此监控任务吗？这将同时删除所有相关数据。</p>
                <div class="modal-footer">
                  <button @click="cancelDelete" class="btn-cancel">取消</button>
                  <button @click="confirmDelete" class="btn-confirm">确定</button>
                </div>
              </div>
            </div>
          </div>






        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 确保引入了View UI
import { Message } from 'view-ui-plus';
import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-moment';
import apiClient from "@/api";

Chart.register(...registerables);

/**
 * 监控数据组件
 * 负责监控任务的创建和数据可视化展示
 */
export default {
  name: 'Monitor',
  data() {
    return {
      // 主题相关
      currentTheme: 'starry',
      themeOptions: [
        { name: 'default', label: '经典' },
        { name: 'starry', label: '星空' },
        { name: 'blue', label: '蓝色' },
        { name: 'purple', label: '紫色' },
        { name: 'green', label: '绿色' },
        { name: 'red', label: '红色' },
        { name: 'orange', label: '橙色' }
      ],
      
      tasks: [], // 任务列表
      currentViewTask: null, // 当前查看的任务
      deleteConfirm: false, // 删除确认状态
      deleteTaskId: null, // 待删除的任务ID
      deleteAwemeId:null,// 待删除的视频ID
      isDataQueried: false, // 添加这个变量来跟踪是否已查询数据
      videoUrl: '', // 视频链接
      selectedDuration: 7, // 默认监控时长
      videoInfo: null, // 添加视频信息存储
      isQuerying: false, // 添加查询状态
      searchQuery: '', // 添加搜索查询字段
      finishedSearchQuery: '', // 添加监控结束任务的搜索查询字段
      // 分页相关变量
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
        loading: false,
        hasMore: true
      },

      // 监控结束任务相关变量
      finishedTasks: [], // 监控结束任务列表
      finishedPagination: {
        page: 1,
        limit: 20,
        total: 0,
        loading: false,
        hasMore: true
      },
      currentFinishedViewTask: null, // 当前查看的监控结束任务
      finishedChart: null, // 监控结束图表实例
      showFinishedTableModal: false, // 是否显示监控结束表格弹窗
      currentFinishedTableTask: null, // 当前查看监控结束表格的任务
      finishedTableData: [], // 监控结束表格数据
      showMonitoringTableModal: false, // 是否显示监控中表格弹窗
      currentMonitoringTableTask: null, // 当前查看监控中表格的任务
      monitoringTableData: [], // 监控中表格数据

      durations: [
        { value: 1, label: '1天' },
        { value: 2, label: '2天' },
        { value: 3, label: '3天' },
        { value: 4, label: '4天' },
        { value: 5, label: '5天' },
        { value: 6, label: '6天' },
        { value: 7, label: '7天' },
        { value: 8, label: '8天' },
        { value: 9, label: '9天' },
        { value: 10, label: '10天' },
        { value: 11, label: '11天' },
        { value: 12, label: '12天' },
        { value: 13, label: '13天' },
        { value: 14, label: '14天' },
        { value: 15, label: '15天' },
        { value: 16, label: '16天' },
        { value: 17, label: '17天' },
        { value: 18, label: '18天' },
        { value: 19, label: '19天' },
        { value: 20, label: '20天' },
        { value: 21, label: '21天' },
        { value: 22, label: '22天' },
        { value: 23, label: '23天' },
        { value: 24, label: '24天' },
        { value: 25, label: '25天' },
        { value: 26, label: '26天' },
        { value: 27, label: '27天' },
        { value: 28, label: '28天' },
        { value: 29, label: '29天' },
        { value: 30, label: '30天' }
      ],
      lastUpdateTime: '', // 最后更新时间
      taskId: null, // 任务ID
      chart: null, // 图表实例
      refreshInterval: null, // 定时刷新间隔
      activeTab: 'monitor', // 当前激活的Tab
      tabs: [
        { name: 'monitor', label: '监控' },
        { name: 'monitoring', label: '监控中' },
        { name: 'finished', label: '监控结束' }
      ],
      // 监控结果数据
      totalPlays: 0,// 总播放量
      maxDailyPlays: 0,// 最高单日播放量
      avgDailyPlays: 0,// 平均每日播放量
      totalLikes: 0,// 总点赞数
      totalComments: 0,// 总评论数
      totalShares: 0// 总分享数
    };
  },
  /**
   * 组件挂载完成后执行
   */
  mounted() {
    try {
      // 初始化主题
      this.initTheme();
      
      // 设置页面标题
      document.title = '作品详细数据监控系统'
      console.log('页面已加载');

      // 获取任务列表 监控中任务
      this.fetchTasks();

      // 获取监控结束任务列表
      this.fetchFinishedTasks();

    } catch (error) {
      console.error('组件挂载错误:', error);
    }
  },
  /**
   * 组件销毁前执行
   */
  beforeDestroy() {
    // 组件销毁前清理定时器
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }

    // 确保图表实例被销毁
    if (this.chart) {
      try {
        this.chart.destroy();
      } catch (e) {
        console.warn('图表销毁异常:', e);
      }
      this.chart = null;
    }
    
    // 清理 body 的主题类名
    document.body.className = '';
  },
  methods: {
    /**
     * 初始化主题
     */
    initTheme() {
      const savedTheme = localStorage.getItem('currentTheme');
      if (savedTheme) {
        this.currentTheme = savedTheme;
      } else {
        // 默认使用星空模式
        this.currentTheme = 'starry';
        localStorage.setItem('currentTheme', 'starry');
      }
      // 将主题类名应用到 body 元素，确保全局样式生效
      document.body.className = `theme-${this.currentTheme}`;
    },

    /**
     * 切换主题（已移至导航栏，此处仅保留监听全局主题变化）
     */
    handleThemeChange(themeName) {
      // 如果是从事件触发的（有 detail 属性）
      if (typeof themeName === 'object' && themeName.detail) {
        themeName = themeName.detail.theme;
      }
      
      // 如果主题没有变化，不执行后续操作
      if (this.currentTheme === themeName) {
        return;
      }
      
      this.currentTheme = themeName;
      localStorage.setItem('currentTheme', themeName);
      document.body.className = `theme-${themeName}`;
    },

    /**
     * 获取主题标签
     */
    getThemeLabel(themeName) {
      const theme = this.themeOptions.find(t => t.name === themeName);
      return theme ? theme.label : '经典';
    },

    /**
     * 处理监控结束任务搜索
     */
    async handleFinishedSearch() {
      // 重置分页信息
      this.finishedPagination.page = 1;
      this.finishedTasks = [];
      await this.fetchFinishedTasks();
    },

    /**
     * 清空监控结束任务搜索
     */
    async clearFinishedSearch() {
      this.finishedSearchQuery = '';
      this.finishedPagination.page = 1;
      this.finishedTasks = [];
      await this.fetchFinishedTasks();
    },

    /**
     * 获取监控结束任务列表
     */
    async fetchFinishedTasks(loadMore = false) {
      try {
        // 如果是加载更多且正在加载中，则直接返回
        if (loadMore && this.finishedPagination.loading) {
          return;
        }

        // 设置加载状态
        this.finishedPagination.loading = true;

        // 如果不是加载更多，重置页码
        if (!loadMore) {
          this.finishedPagination.page = 1;
          this.finishedTasks = [];
        }

        // 构造请求参数
        const params = {
          page: this.finishedPagination.page,
          limit: this.finishedPagination.limit,
          task_status: 'expired' // 获取已结束的任务
        };

        // 如果有搜索关键词，添加到参数中
        if (this.finishedSearchQuery) {
          params.search = this.finishedSearchQuery;
        }

        const response = await apiClient.post('monitor/gettasklist', params);

        if (response.data.code === 200) {
          const data = response.data.data;
          // 更新分页信息
          this.finishedPagination.total = data.total;
          this.finishedPagination.page = data.page;

          if (loadMore) {
            // 加载更多数据，追加到现有列表
            this.finishedTasks = [...this.finishedTasks, ...data.list];
          } else {
            // 刷新数据，替换现有列表
            this.finishedTasks = data.list || [];
          }

          // 判断是否还有更多数据
          this.finishedPagination.hasMore = this.finishedTasks.length < this.finishedPagination.total;
        } else {
          this.$Message.error(response.data.msg || '获取监控结束任务列表失败');
          this.showCopyToast(response.data.msg || '获取监控结束任务列表失败');
        }
      } catch (error) {
        console.error('获取监控结束任务列表失败:', error);
        this.$Message.error('获取监控结束任务列表失败');
        this.showCopyToast('获取监控结束任务列表失败');
      } finally {
        this.finishedPagination.loading = false;
      }
    },

    /**
     * 处理搜索
     */
    async handleSearch() {
      // 重置分页信息
      this.pagination.page = 1;
      this.tasks = [];
      await this.fetchTasks();
    },

    /**
     * 清空搜索
     */
    async clearSearch() {
      this.searchQuery = '';
      this.pagination.page = 1;
      this.tasks = [];
      await this.fetchTasks();
    },

    /**
     * 获取任务列表
     */
    async fetchTasks(loadMore = false) {
      try {
        // 如果是加载更多且正在加载中，则直接返回
        if (loadMore && this.pagination.loading) {
          return;
        }

        // 设置加载状态
        this.pagination.loading = true;

        // 如果不是加载更多，重置页码
        if (!loadMore) {
          this.pagination.page = 1;
          this.tasks = [];
        }

        // 构造请求参数
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          task_status: 'active'
        };

        // 如果有搜索关键词，添加到参数中
        if (this.searchQuery) {
          params.search = this.searchQuery;
        }

        const response = await apiClient.post('monitor/gettasklist', params);

        if (response.data.code === 200) {
          const data = response.data.data;
          // 更新分页信息
          this.pagination.total = data.total;// 总记录数
          this.pagination.page = data.page;// 当前页码

          if (loadMore) {
            // 加载更多数据，追加到现有列表
            this.tasks = [...this.tasks, ...data.list];
          } else {
            // 刷新数据，替换现有列表
            this.tasks = data.list || [];
          }

          // 判断是否还有更多数据
          this.pagination.hasMore = this.tasks.length < this.pagination.total;
        } else {
          this.$Message.error(response.data.msg || '获取任务列表失败');
          this.showCopyToast(response.data.msg || '获取任务列表失败');
        }
      } catch (error) {
        console.error('获取任务列表失败:', error);
        this.$Message.error('获取任务列表失败');
        this.showCopyToast('获取任务列表失败');
      } finally {
        this.pagination.loading = false;
      }
    },

   /* /!**
     * 获取监控结束任务列表
     *!/
    async fetchFinishedTasks(loadMore = false) {
      try {
        // 如果是加载更多且正在加载中，则直接返回
        if (loadMore && this.finishedPagination.loading) {
          return;
        }

        // 设置加载状态
        this.finishedPagination.loading = true;

        // 如果不是加载更多，重置页码
        if (!loadMore) {
          this.finishedPagination.page = 1;
          this.finishedTasks = [];
        }

        const response = await apiClient.post('monitor/gettasklist', {
          page: this.finishedPagination.page,
          limit: this.finishedPagination.limit,
          task_status: 'expired' // 获取已结束的任务
        });

        if (response.data.code === 200) {
          const data = response.data.data;
          // 更新分页信息
          this.finishedPagination.total = data.total;
          this.finishedPagination.page = data.page;

          if (loadMore) {
            // 加载更多数据，追加到现有列表
            this.finishedTasks = [...this.finishedTasks, ...data.list];
          } else {
            // 刷新数据，替换现有列表
            this.finishedTasks = data.list || [];
          }

          // 判断是否还有更多数据
          this.finishedPagination.hasMore = this.finishedTasks.length < this.finishedPagination.total;
        } else {
          this.$Message.error(response.data.msg || '获取监控结束任务列表失败');
          this.showCopyToast(response.data.msg || '获取监控结束任务列表失败');
        }
      } catch (error) {
        console.error('获取监控结束任务列表失败:', error);
        this.$Message.error('获取监控结束任务列表失败');
        this.showCopyToast('获取监控结束任务列表失败');
      } finally {
        this.finishedPagination.loading = false;
      }
    },*/

    /**
     * 处理监控结束任务滚动事件，实现无限滚动加载
     */
    handleFinishedScroll(event) {
      // 获取滚动容器
      const container = event.target;
      // 检查是否滚动到底部
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
        // 如果还有更多数据且未在加载中，则加载下一页
        if (this.finishedPagination.hasMore && !this.finishedPagination.loading) {
          this.loadMoreFinishedTasks();
        }
      }
    },

    /**
     * 加载更多监控结束任务
     */
    async loadMoreFinishedTasks() {
      // 如果已经没有更多数据或正在加载中，则返回
      if (!this.finishedPagination.hasMore || this.finishedPagination.loading) {
        return;
      }
      // 更新页码
      this.finishedPagination.page++;
      await this.fetchFinishedTasks(true); // true表示加载更多
    },

    /**
     * 查看监控结束任务图表
     */
    viewFinishedChart(task) {
      this.currentFinishedViewTask = task;
      // 初始化图表
      this.initFinishedChart();
    },

    /**
     * 关闭监控结束任务图表弹窗
     */
    closeFinishedChartModal() {
      this.currentFinishedViewTask = null;
    },

    /**
     * 查看监控结束任务表格
     */
    viewFinishedTable(task) {
      this.currentFinishedTableTask = task;
      this.showFinishedTableModal = true;
      // 获取表格数据
      this.fetchFinishedTableData(task.task_id);
    },

    /**
     * 关闭监控结束任务表格弹窗
     */
    closeFinishedTableModal() {
      this.showFinishedTableModal = false;
      this.currentFinishedTableTask = null;
      this.finishedTableData = [];
    },

    /**
     * 查看监控中任务表格
     */
    viewMonitoringTable(task) {
      this.currentMonitoringTableTask = task;
      this.showMonitoringTableModal = true;
      // 获取表格数据
      this.fetchMonitoringTableData(task.task_id);
    },

    /**
     * 关闭监控中任务表格弹窗
     */
    closeMonitoringTableModal() {
      this.showMonitoringTableModal = false;
      this.currentMonitoringTableTask = null;
      this.monitoringTableData = [];
    },

    /**
     * 导出监控中表格Excel
     */
    exportMonitoringTableToExcel() {
      if (!this.monitoringTableData || this.monitoringTableData.length === 0) {
        this.$Message.warning('暂无数据可导出');
        this.showCopyToast('暂无数据可导出');
        return;
      }

      try {
        // 构建CSV内容
        const headers = ['作品链接', '日期', '播放量', '点赞量', '评论量', '分享量'];
        const videoUrl = `https://www.douyin.com/video/${this.currentMonitoringTableTask.content_id}`;
        const csvContent = [
          headers.join(','),
          ...this.monitoringTableData.map(row => [
            videoUrl,
            row.date,
            row.play_count,
            row.like_count,
            row.comment_count,
            row.share_count
          ].join(','))
        ].join('\n');

        // 添加BOM以支持中文
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        
        // 创建下载链接
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        // 生成文件名：任务ID_视频ID_日期
        const fileName = `监控数据_${this.currentMonitoringTableTask.task_id}_${this.currentMonitoringTableTask.content_id}_${new Date().getTime()}.csv`;
        
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.$Message.success('导出成功');
        this.showCopyToast('导出成功');
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$Message.error('导出失败');
        this.showCopyToast('导出失败');
      }
    },

    /**
     * 获取监控中任务表格数据
     */
    async fetchMonitoringTableData(taskId) {
      try {
        const response = await apiClient.post('monitor/get-data', {
          task_id: taskId,
          period: 'daily',
          is_cumulative: 1
        });

        const data = response.data.data;
        this.processMonitoringTableData(data);
      } catch (error) {
        console.error('获取监控中任务表格数据失败:', error);
        this.$Message.error('获取表格数据失败');
        this.showCopyToast('获取表格数据失败');
      }
    },

    /**
     * 处理监控中表格数据
     */
    processMonitoringTableData(data) {
      // 验证数据格式
      if (!Array.isArray(data)) {
        console.error('数据格式错误：期望数组格式');
        this.showCopyToast('数据格式错误：期望数组格式');
        return;
      }

      // 过滤无效数据
      const validData = data.filter(item =>
          item.timestamp && item.value !== undefined
      );

      if (validData.length === 0) {
        console.warn('没有有效数据用于显示表格');
        this.showCopyToast('没有有效数据用于显示表格');
        return;
      }

      // 按数据类型分组
      const groupedData = {};
      validData.forEach(item => {
        if (!groupedData[item.data_type]) {
          groupedData[item.data_type] = [];
        }
        groupedData[item.data_type].push(item);
      });

      // 获取所有唯一的日期并排序
      const allDates = [...new Set(validData.map(item => item.created_at))].sort();

      // 构建表格数据
      const tableData = allDates.map(date => {
        const row = { date: date };
        
        // 获取每种数据类型在该日期的值
        const playData = groupedData['play_count']?.find(item => item.created_at === date);
        const likeData = groupedData['like_count']?.find(item => item.created_at === date);
        const commentData = groupedData['comment_count']?.find(item => item.created_at === date);
        const shareData = groupedData['share_count']?.find(item => item.created_at === date);

        row.play_count = playData ? playData.value : '-';
        row.like_count = likeData ? likeData.value : '-';
        row.comment_count = commentData ? commentData.value : '-';
        row.share_count = shareData ? shareData.value : '-';

        return row;
      });

      this.monitoringTableData = tableData;
    },

    /**
     * 导出Excel表格
     */
    exportToExcel() {
      if (!this.finishedTableData || this.finishedTableData.length === 0) {
        this.$Message.warning('暂无数据可导出');
        this.showCopyToast('暂无数据可导出');
        return;
      }

      try {
        // 构建CSV内容
        const headers = ['作品链接', '日期', '播放量', '点赞量', '评论量', '分享量'];
        const videoUrl = `https://www.douyin.com/video/${this.currentFinishedTableTask.content_id}`;
        const csvContent = [
          headers.join(','),
          ...this.finishedTableData.map(row => [
            videoUrl,
            row.date,
            row.play_count,
            row.like_count,
            row.comment_count,
            row.share_count
          ].join(','))
        ].join('\n');

        // 添加BOM以支持中文
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        
        // 创建下载链接
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        // 生成文件名：任务ID_视频ID_日期
        const fileName = `监控数据_${this.currentFinishedTableTask.task_id}_${this.currentFinishedTableTask.content_id}_${new Date().getTime()}.csv`;
        
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.$Message.success('导出成功');
        this.showCopyToast('导出成功');
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$Message.error('导出失败');
        this.showCopyToast('导出失败');
      }
    },

    /**
     * 获取监控结束任务表格数据
     */
    async fetchFinishedTableData(taskId) {
      try {
        const response = await apiClient.post('monitor/get-data', {
          task_id: taskId,
          period: 'daily',
          is_cumulative: 1
        });

        const data = response.data.data;
        this.processTableData(data);
      } catch (error) {
        console.error('获取监控结束任务表格数据失败:', error);
        this.$Message.error('获取表格数据失败');
        this.showCopyToast('获取表格数据失败');
      }
    },

    /**
     * 处理表格数据
     */
    processTableData(data) {
      // 验证数据格式
      if (!Array.isArray(data)) {
        console.error('数据格式错误：期望数组格式');
        this.showCopyToast('数据格式错误：期望数组格式');
        return;
      }

      // 过滤无效数据
      const validData = data.filter(item =>
          item.timestamp && item.value !== undefined
      );

      if (validData.length === 0) {
        console.warn('没有有效数据用于显示表格');
        this.showCopyToast('没有有效数据用于显示表格');
        return;
      }

      // 按数据类型分组
      const groupedData = {};
      validData.forEach(item => {
        if (!groupedData[item.data_type]) {
          groupedData[item.data_type] = [];
        }
        groupedData[item.data_type].push(item);
      });

      // 获取所有唯一的日期并排序
      const allDates = [...new Set(validData.map(item => item.created_at))].sort();

      // 构建表格数据
      const tableData = allDates.map(date => {
        const row = { date: date };
        
        // 获取每种数据类型在该日期的值
        const playData = groupedData['play_count']?.find(item => item.created_at === date);
        const likeData = groupedData['like_count']?.find(item => item.created_at === date);
        const commentData = groupedData['comment_count']?.find(item => item.created_at === date);
        const shareData = groupedData['share_count']?.find(item => item.created_at === date);

        row.play_count = playData ? playData.value : '-';
        row.like_count = likeData ? likeData.value : '-';
        row.comment_count = commentData ? commentData.value : '-';
        row.share_count = shareData ? shareData.value : '-';

        return row;
      });

      this.finishedTableData = tableData;
    },

    /**
     * 初始化监控结束任务图表
     */
    initFinishedChart() {
      if (!this.currentFinishedViewTask) return;

      // 清除之前的图表
      if (this.finishedChart) {
        this.finishedChart.destroy();
      }

      // 获取监控数据
      this.fetchFinishedChartData(this.currentFinishedViewTask.task_id);
    },

    /**
     * 获取监控结束任务数据（用于图表）
     */
    async fetchFinishedChartData(taskId) {
      try {
        const response = await apiClient.post('monitor/get-data', {
          task_id: taskId,
          period: 'daily',
          is_cumulative: 1
        });

        const data = response.data.data;
        this.renderFinishedChart(data);
      } catch (error) {
        console.error('获取监控结束任务数据失败:', error);
      }
    },

    /**
     * 渲染监控结束任务图表
     */
    renderFinishedChart(data) {
      // 验证数据格式，确保传入的数据是数组类型
      if (!Array.isArray(data)) {
        console.error('数据格式错误：期望数组格式');
        this.showCopyToast('数据格式错误：期望数组格式');
        return;
      }

      // 过滤无效数据，只保留包含时间戳且值不为undefined的数据项
      const validData = data.filter(item =>
          item.timestamp && item.value !== undefined
      );

      // 如果没有有效数据，则输出警告并返回
      if (validData.length === 0) {
        console.warn('没有有效数据用于渲染图表');
        this.showCopyToast('没有有效数据用于渲染图表');
        this.currentFinishedViewTask = null;
        return;
      }

      // 按数据类型分组数据，创建一个对象来存储不同类型的数据
      const groupedData = {};
      validData.forEach(item => {
        // 如果该数据类型还没有在groupedData中初始化，则创建一个空数组
        if (!groupedData[item.data_type]) {
          groupedData[item.data_type] = [];
        }
        // 将当前数据项添加到对应类型的数据数组中
        groupedData[item.data_type].push(item);
      });

      // 定义需要展示的数据类型列表
      const dataTypes = ['play_count', 'like_count', 'comment_count', 'share_count'];
      // 为每种数据类型定义显示标签和颜色配置
      const dataTypeConfig = {
        'play_count': { label: '播放量', color: '#f56c6c' },
        'like_count': { label: '点赞量', color: '#409eff' },
        'comment_count': { label: '评论量', color: '#67c23a' },
        'share_count': { label: '分享量', color: '#e6a23c' }
      };

      // 为每种数据类型创建图表数据集
      const datasets = dataTypes
          // 过滤出在groupedData中存在的数据类型
          .filter(type => groupedData[type] && groupedData[type].length > 0)
          // 为每种数据类型创建对应的图表配置
          .map(type => {
            const config = dataTypeConfig[type];
            return {
              label: config.label,  // 数据集标签
              data: groupedData[type].map(item => item.value),  // 数据值数组
              borderColor: config.color,  // 边框颜色
              backgroundColor: `${config.color}20`, // 背景颜色（带透明度）
              fill: false,  // 不填充曲线下方区域
              pointRadius: 4,  // 数据点半径
              pointHitRadius: 8,  // 数据点点击热区半径
              yAxisID: 'y'  // Y轴ID
            };
          });

      // 获取所有唯一的日期标签并按时间排序
      const allTimestamps = [...new Set(validData.map(item => item.created_at))].sort();

      // 在下次DOM更新后执行图表渲染
      this.$nextTick(() => {
        // 检查图表canvas元素是否存在
        if (this.$refs.finishedChartCanvas) {
          // 获取canvas的2D绘图上下文
          const ctx = this.$refs.finishedChartCanvas.getContext('2d');
          // 确保上下文获取成功
          if (ctx) {
            // 如果已有图表实例，则先销毁避免内存泄漏
            if (this.finishedChart) {
              this.finishedChart.destroy();
            }

            // 创建新的图表实例
            this.finishedChart = new Chart(ctx, {
              type: 'line',  // 图表类型为折线图
              data: {
                labels: allTimestamps,  // X轴标签（时间戳）
                datasets: datasets  // 数据集
              },
              options: {
                responsive: true,  // 响应式设计
                maintainAspectRatio: false,  // 不保持宽高比
                scales: {
                  x: {
                    type: 'time',  // X轴为时间类型
                    time: {
                      unit: 'day',  // 时间单位为天
                      tooltipFormat: 'YYYY-MM-DD',  // 工具提示格式
                      displayFormats: {
                        day: 'MM-DD'  // 显示格式
                      }
                    },
                    ticks: {
                      autoSkip: false,  // 不自动跳过标签
                      maxRotation: 0,   // 最大旋转角度
                      minRotation: 0    // 最小旋转角度
                    }
                  },
                  y: {
                    beginAtZero: true,  // Y轴从0开始
                    title: {
                      display: true,   // 显示Y轴标题
                      text: '数值'      // Y轴标题文本
                    }
                  }
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      // 自定义工具提示标签格式
                      label: function(context) {
                        const value = context.parsed.y;
                        return `${context.dataset.label}: ${value.toLocaleString()}`;
                      }
                    }
                  },
                  legend: {
                    display: true,    // 显示图例
                    position: 'top'   // 图例位置在顶部
                  }
                }
              }
            });
          }
        }
      });
    },

   /* /!**
     * 获取任务列表
     *!/
    async fetchTasks(loadMore = false) {
      try {
        // 如果是加载更多且正在加载中，则直接返回
        if (loadMore && this.pagination.loading) {
          return;
        }

        // 设置加载状态
        this.pagination.loading = true;

        // 如果不是加载更多，重置页码
        if (!loadMore) {
          this.pagination.page = 1;
          this.tasks = [];
        }

        const response = await apiClient.post('monitor/gettasklist', {
          page: this.pagination.page,
          limit: this.pagination.limit,
          task_status:'active'
        });

        if (response.data.code === 200) {
          const data = response.data.data;
          // 更新分页信息
          this.pagination.total = data.total;// 总记录数
          this.pagination.page = data.page;// 当前页码

          if (loadMore) {
            // 加载更多数据，追加到现有列表
            this.tasks = [...this.tasks, ...data.list];
          } else {
            // 刷新数据，替换现有列表
            this.tasks = data.list || [];
          }

          // 判断是否还有更多数据
          this.pagination.hasMore = this.tasks.length < this.pagination.total;
        } else {
          this.$Message.error(response.data.msg || '获取任务列表失败');
          this.showCopyToast(response.data.msg || '获取任务列表失败');
        }
      } catch (error) {
        console.error('获取任务列表失败:', error);
        this.$Message.error('获取任务列表失败');
        this.showCopyToast('获取任务列表失败');
      } finally {
        this.pagination.loading = false;
      }
    },*/
    /**
     * 处理滚动事件，实现无限滚动加载
     */
    handleScroll(event) {
      // 获取滚动容器
      const container = event.target;
      // 检查是否滚动到底部
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
        // 如果还有更多数据且未在加载中，则加载下一页
        if (this.pagination.hasMore && !this.pagination.loading) {
          this.loadMoreTasks();
        }
      }
    },

    /**
     * 加载更多任务
     */
    async loadMoreTasks() {
      // 如果已经没有更多数据或正在加载中，则返回
      if (!this.pagination.hasMore || this.pagination.loading) {
        return;
      }
      // 更新页码
      this.pagination.page++;
      await this.fetchTasks(true); // true表示加载更多
    },

    /**
     * 查看图表
     */
    viewChart(task) {
      this.currentViewTask = task;
      // 初始化图表
      this.initChart();
    },

    /**
     * 关闭图表弹窗
     */
    closeChartModal() {
      this.currentViewTask = null;
    },

    /**
     * 确认删除任务
     */
    confirmDeleteTask(task) {
      this.deleteTaskId = task.task_id;// 保存任务ID
      this.deleteAwemeId = task.content_id;  // 保存视频ID（从content_id获取）
      this.deleteConfirm = true;// 显示删除确认框
    },

    /**
     * 确认删除操作
     */
    async confirmDelete() {
      try {
        // 删除任务
        await apiClient.post(`monitor/delete-task`, {
          task_id: this.deleteTaskId
        });

        // 删除所有相关数据
        await apiClient.post(`monitor/delete-awemedata`, {
          aweme_id:  this.deleteAwemeId  // 使用task对象中的aweme_id
        });

        // 根据当前活动的 Tab 更新对应的任务列表
        if (this.activeTab === 'monitoring') {
          // 更新监控中任务列表
          await this.fetchTasks();
        } else if (this.activeTab === 'finished') {
          // 更新监控结束任务列表
          await this.fetchFinishedTasks();
        }

        this.$Message.success('任务删除成功');
        this.showCopyToast('任务删除成功')

      } catch (error) {
        console.error('删除任务失败:', error);
        this.$Message.error('删除任务失败');
        this.showCopyToast('删除任务失败')
      } finally {
        this.deleteConfirm = false;
        this.deleteTaskId = null;
      }
    },

    /**
     * 取消删除操作
     */
    cancelDelete() {
      // 取消删除操作
      this.deleteConfirm = false;
      // 重置任务ID
      this.deleteTaskId = null;
    },

    /**
     * 初始化图表
     */
    initChart() {
      if (!this.currentViewTask) return;

      // 清除之前的图表
      if (this.chart) {
        this.chart.destroy();
      }

      // 获取监控数据
      this.fetchChartData(this.currentViewTask.task_id);
    },

    /**
     * 清空视频链接
     */
    clearVideoUrl() {
      this.videoUrl = '';
      this.videoInfo = null; // 同时清空视频信息
      this.isDataQueried = false; // 重置数据查询状态
    },

    /**
     * 显示复制提示消息
     * @param {string} message - 要显示的消息
     */
    showCopyToast(message) {
      this.$Message.info(message);
    },

    /**
     * 检查监控时长点击
     */
    handleDurationChange() {
      if (!this.isDataQueried) {
        this.$Message.warning('请先点击查询作品数据后才可以监控任务');
        this.showCopyToast('请先点击查询作品数据后才可以监控任务');
        // 重置为默认值
        this.selectedDuration = 7;
      }
    },
    /**
     * 开始监控
     * 创建监控任务并启动自动刷新
     */
    async startMonitoring() {
      try {
        // 检查是否已查询视频信息
        if (!this.videoInfo) {
          this.$Message.warning('请先查询视频信息');
          return;
        }

        // 使用已查询的视频信息中的 aweme_id
        const videoId = this.videoInfo.aweme_id;

        // 使用已查询的视频信息中的描述作为 content_title
        const contentTitle = this.videoInfo.desc || '';
        console.log('videoInfo:', this.videoInfo)
        console.log('开始监控:', videoId, contentTitle)
        // 创建监控任务
        const response = await apiClient.post('monitor/create-task', {
          aweme_id: videoId,
          content_title: contentTitle,  // 使用视频描述作为标题
          monitor_duration: this.selectedDuration, // 监控时长
          start_time: new Date().toISOString(),    // 开始时间
          publish_time: this.videoInfo.publish_time, // 作品发布的时间（时间戳）
          content_image: this.videoInfo.aweme_cover,    // 头像
          end_time: this.calculateEndTime(this.selectedDuration) // 结束时间
        });

        if (response.data.code === 200) {
          // 保存任务ID
          this.taskId = response.data.data.task_id;

          // 更新最后更新时间
          this.lastUpdateTime = new Date().toLocaleString();

          // 切换到监控中Tab
          this.activeTab = 'monitoring';

          // 开始自动刷新图表
          //this.startAutoRefresh();
          this.showCopyToast('监控任务创建成功');
          this.$Message.success('监控任务创建成功');
          // 获取任务列表
         await this.fetchTasks();

        } else {
          this.$Message.error(response.data.msg || '创建监控任务失败');
          this.showCopyToast(response.data.msg || '创建监控任务失败')
        }

      } catch (error) {
        console.error('创建监控任务失败:', error);
        this.$Message.error('创建监控任务失败: ' + (error.response?.data?.msg || error.message));
      }
    },



    /**
     * 查询视频信息
     */
    async queryVideo() {
      if (!this.videoUrl.trim()) {
        this.$Message.warning('请输入视频链接');
        return;
      }

      try {
        this.isQuerying = true;

        // 提取作品链接
        const extractedUrl = this.extractDouyinUrl(this.videoUrl);

        if (!extractedUrl) {
          this.$Message.warning('未找到有效的作品视频链接');
          this.showCopyToast('未找到有效的作品视频链接')
          return;
        }

        let videoId = null;

        // 处理不同格式的链接
        if (extractedUrl.startsWith('http')) {
          // 处理新链接格式: https://www.iesdouyin.com/share/video/7523965230288817449
          const shareLinkMatch = extractedUrl.match(/https?:\/\/www\.iesdouyin\.com\/share\/video\/(\d+)/);

          if (shareLinkMatch && shareLinkMatch[1]) {
            videoId = shareLinkMatch[1];
          } else {
            // 处理长链接格式: https://www.douyin.com/video/7234567890123456789
            const longLinkMatch = extractedUrl.match(/https?:\/\/www\.douyin\.com\/video\/(\d+)/);
            if (longLinkMatch && longLinkMatch[1]) {
              videoId = longLinkMatch[1];
            } else {
              // 处理modal_id参数格式: https://www.douyin.com/jingxuan?modal_id=7536526157475319092
              const modalIdMatch = extractedUrl.match(/[?&]modal_id=(\d+)/);
              if (modalIdMatch && modalIdMatch[1]) {
                videoId = modalIdMatch[1];
              } else {
                // 处理短链接格式: https://v.douyin.com/xxxxxx/
                const shortLinkMatch = extractedUrl.match(/https?:\/\/v\.douyin\.com\/([a-zA-Z0-9\-_]+)/);
                if (shortLinkMatch && shortLinkMatch[1]) {
                  try {
                    // 调用后端API解析短链接
                    const response = await apiClient.post('query/parse-link', {
                      douyin_url: extractedUrl
                    });

                    // 如果解析成功
                    if (response.data.code === 200 && response.data.data && response.data.data.video_id) {
                      // 设置视频ID
                      videoId = response.data.data.video_id;
                    } else {
                      this.$Message.error('链接解析失败，请检查链接是否正确');
                      this.showCopyToast( '链接解析失败，请检查链接是否正确')
                      return;
                    }
                  } catch (error) {
                    // 处理不同类型的错误
                    if (error.response) {
                      // 服务器返回错误状态码
                      this.$Message.error(`服务器错误: ${error.response.status}`);
                      this.showCopyToast( `服务器错误: ${error.response.status}`)
                    } else if (error.request) {
                      // 网络请求无响应
                      this.$Message.error('网络请求无响应，请检查网络连接');
                      this.showCopyToast( '网络请求无响应，请检查网络连接')
                    } else {
                      // 其他错误
                      this.$Message.error('请求配置错误');
                      this.showCopyToast( '请求配置错误')
                    }
                    return;
                  }
                } else {
                  // 未匹配到任何已知链接格式
                  this.$Message.warning('未识别到有效的作品链接格式');
                  this.showCopyToast( '未识别到有效的作品链接格式')
                  return;
                }
              }
            }
          }
        } else {
          // 处理纯数字ID输入
          const isPureNumber = /^\d+$/.test(extractedUrl);
          if (!isPureNumber) {
            this.$Message.warning('请输入有效的数字ID');
            return;
          }

          videoId = extractedUrl.replace(/[^\d]/g, '');
        }

        // 检查是否获取到有效的视频ID
        if (!videoId) {
          this.$Message.warning('未识别到有效的作品链接或ID格式');
          this.showCopyToast( '未识别到有效的作品链接或ID格式')
          return;
        }

        // 显示加载提示
        const loading = this.$Message.loading({
          content: '正在查询视频信息...',
          duration: 0
        });

        this.showCopyToast( '正在查询视频信息')

        // 发送请求到后端API获取视频详情
        const response = await apiClient.post('monitor/douyin_video_detail', {
          aweme_id: videoId
        });

        // 关闭加载提示
        this.$Message.destroy();

        if (response.data.code === 200) {
          this.videoInfo = response.data.data;
          this.isDataQueried = true; // 添加这行
          this.$Message.success('视频信息查询成功');
          this.showCopyToast('视频信息查询成功')
        } else {
          this.$Message.error('查询失败: ' + (response.data.msg || '未知错误'));
          this.showCopyToast('查询失败: ' + (response.data.msg || '未知错误'))
        }
      } catch (error) {
        // 关闭加载提示
        this.$Message.destroy();
        console.error('查询视频信息失败:', error);
        this.$Message.error('查询视频信息失败，请稍后重试');
        this.showCopyToast( '查询视频信息失败，请稍后重试')
      } finally {
        this.isQuerying = false;
      }
    },

    /**
     * 提取文本中的作品链接
     * @param {string} text - 输入文本
     * @returns {string} 提取到的链接或原文本
     */
    extractDouyinUrl(text) {
      if (!text) return '';

      // 多种作品链接格式的正则表达式
      const urlPatterns = [
        // 完整的作品链接
        /https?:\/\/v\.douyin\.com\/[a-zA-Z0-9_\-\/?=&#.]+/i,
        /https?:\/\/www\.douyin\.com\/[a-zA-Z0-9_\-\/?=&#.]+/i,
        // 短链接格式
        /https?:\/\/v\.douyin\.com\/[a-zA-Z0-9]+/i,
        // 包含视频ID的链接
        /https?:\/\/[a-zA-Z0-9\-\.]*douyin\.com\/video\/[0-9]+/i,
        // 包含modal_id参数的链接
        /https?:\/\/[a-zA-Z0-9\-\.]*douyin\.com\/[a-zA-Z0-9_\-\/?=&#]*modal_id=([0-9]+)/i,
        // 其他可能的作品域名
        /https?:\/\/[a-zA-Z0-9\-\.]*iesdouyin\.com\/[a-zA-Z0-9_\-\/?=&#.]+/i
      ];

      // 尝试匹配各种链接格式
      for (const pattern of urlPatterns) {
        const match = text.match(pattern);
        if (match) {
          return match[0];
        }
      }

      // 如果没有找到链接，返回原文本
      return text.trim();
    },
    /**
     * 停止监控
     */
    stopMonitoring() {
      // 清除定时器
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
      
      // 切换到监控结束Tab
      this.activeTab = 'finished';
    },

    /**
     * 提取视频ID
     * @param {string} url 视频链接
     * @returns {string} 视频ID
     */
    extractVideoId(url) {
      // 这里需要根据实际的作品链接格式进行调整
      // 示例：https://v.douyin.com/abc123/
      const match = url.match(/\/([a-zA-Z0-9]+)\//);
      return match ? match[1] : '';
    },

    /**
     * 计算结束时间
     * @param {number} days 天数
     * @returns {string} 结束时间字符串
     */
    calculateEndTime(days) {
      const now = new Date();
      now.setDate(now.getDate() + days);
      return now.toISOString();
    },

    /**
     * 更新结束时间
     * 当监控时长改变时更新结束时间
     */
    updateEndTime() {
      // 这里可以添加逻辑来更新结束时间
    },

    /**
     * 开始自动刷新
     * 每分钟刷新一次数据
     */
    startAutoRefresh() {
      // 清除之前的定时器
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }

      // 设置新的定时器
      this.refreshInterval = setInterval(() => {
        this.fetchChartData();
      }, 60000); // 每分钟执行一次
    },

    /**
     * 获取监控数据（用于图表）
     */
    async fetchChartData(taskId) {
      try {
        const response = await apiClient.post('monitor/get-data', {

            task_id: taskId,// 任务ID
           /* data_type: 'share_count',*/
            period: 'daily',// 时间粒度 按天
            is_cumulative: 1// 是否累计

        });

        const data = response.data.data;
        this.renderChart(data);
        this.lastUpdateTime = new Date().toLocaleString();
      } catch (error) {
        console.error('获取监控数据失败:', error);
      }
    },


    /**
     * 渲染图表
     */
    renderChart(data) {
      // 验证数据格式，确保传入的数据是数组类型
      if (!Array.isArray(data)) {
        console.error('数据格式错误：期望数组格式');
        this.showCopyToast('数据格式错误：期望数组格式')
        return;
      }

      // 过滤无效数据，只保留包含时间戳且值不为undefined的数据项
      const validData = data.filter(item =>
          item.timestamp && item.value !== undefined
      );

      // 如果没有有效数据，则输出警告并返回
      if (validData.length === 0) {
        console.warn('没有有效数据用于渲染图表');
        this.showCopyToast('没有有效数据用于渲染图表')
        this.currentViewTask=null;
        return;
      }

      // 按数据类型分组数据，创建一个对象来存储不同类型的数据
      const groupedData = {};
      validData.forEach(item => {
        // 如果该数据类型还没有在groupedData中初始化，则创建一个空数组
        if (!groupedData[item.data_type]) {
          groupedData[item.data_type] = [];
        }
        // 将当前数据项添加到对应类型的数据数组中
        groupedData[item.data_type].push(item);
      });

      // 定义需要展示的数据类型列表
      const dataTypes = ['play_count', 'like_count', 'comment_count', 'share_count'];
      // 为每种数据类型定义显示标签和颜色配置
      const dataTypeConfig = {
        'play_count': { label: '播放量', color: '#f56c6c' },
        'like_count': { label: '点赞量', color: '#409eff' },
        'comment_count': { label: '评论量', color: '#67c23a' },
        'share_count': { label: '分享量', color: '#e6a23c' }
      };

      // 为每种数据类型创建图表数据集
      const datasets = dataTypes
          // 过滤出在groupedData中存在的数据类型
          .filter(type => groupedData[type] && groupedData[type].length > 0)
          // 为每种数据类型创建对应的图表配置
          .map(type => {
            const config = dataTypeConfig[type];
            return {
              label: config.label,  // 数据集标签
              data: groupedData[type].map(item => item.value),  // 数据值数组
              borderColor: config.color,  // 边框颜色
              backgroundColor: `${config.color}20`, // 背景颜色（带透明度）
              fill: false,  // 不填充曲线下方区域
              pointRadius: 4,  // 数据点半径
              pointHitRadius: 8,  // 数据点点击热区半径
              yAxisID: 'y'  // Y轴ID
            };
          });

      // 获取所有唯一的日期标签并按时间排序
      const allTimestamps = [...new Set(validData.map(item => item.created_at))].sort();

      // 在下次DOM更新后执行图表渲染
      this.$nextTick(() => {
        // 检查图表canvas元素是否存在
        if (this.$refs.chartCanvas) {
          // 获取canvas的2D绘图上下文
          const ctx = this.$refs.chartCanvas.getContext('2d');
          // 确保上下文获取成功
          if (ctx) {
            // 如果已有图表实例，则先销毁避免内存泄漏
            if (this.chart) {
              this.chart.destroy();
            }

            // 创建新的图表实例
            this.chart = new Chart(ctx, {
              type: 'line',  // 图表类型为折线图
              data: {
                labels: allTimestamps,  // X轴标签（时间戳）
                datasets: datasets  // 数据集
              },
              options: {
                responsive: true,  // 响应式设计
                maintainAspectRatio: false,  // 不保持宽高比
                scales: {
                  x: {
                    type: 'time',  // X轴为时间类型
                    time: {
                      unit: 'day',  // 时间单位为天
                      tooltipFormat: 'YYYY-MM-DD',  // 工具提示格式
                      displayFormats: {
                        day: 'MM-DD'  // 显示格式
                      }
                    },
                    ticks: {
                      autoSkip: false,  // 不自动跳过标签
                      maxRotation: 0,   // 最大旋转角度
                      minRotation: 0    // 最小旋转角度
                    }
                  },
                  y: {
                    beginAtZero: true,  // Y轴从0开始
                    title: {
                      display: true,   // 显示Y轴标题
                      text: '数值'      // Y轴标题文本
                    }
                  }
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      // 自定义工具提示标签格式
                      label: function(context) {
                        const value = context.parsed.y;
                        return `${context.dataset.label}: ${value.toLocaleString()}`;
                      }
                    }
                  },
                  legend: {
                    display: true,    // 显示图例
                    position: 'top'   // 图例位置在顶部
                  }
                }
              }
            });
          }
        }
      });
    }

  }
};
</script>

<style scoped>

/* 添加搜索框样式 */
.search-container {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
}

.search-input {
  /* 设置宽度 */
  flex: 1;
  /* 设置内边距 */
  padding: 1rem;
  /* 设置边框 */
  border: 2px solid #e1e5e9;
  /* 设置圆角 */
  border-radius: 8px;
  /* 设置字体大小 */
  font-size: 1rem;
  /* 设置过渡效果 */
  transition: all 0.3s ease;
  /* 设置占位符颜色 */
  color: #666;
}
.submit-btn-search{
  /* 设置背景色 */
  background-color: #ff6b6b;
  /* 设置颜色 */
  color: white;
  /* 设置边框 */
  border: none;
  /* 设置圆角 */
  border-radius: 8px;
  /* 设置内边距 */
  padding: 1rem 2rem;
  /* 设置字体大小 */
  font-size: 1rem;
  /* 设置字体粗细 */
  font-weight: 600;
  /* 设置光标 */
  cursor: pointer;
  /* 设置过渡效果 */
  transition: all 0.3s ease;
  /* 设置用户选择 */
  user-select: none;
}

/* 清空按钮样式 - 用于搜索框 */
.clear-btn-search {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 80px;
  height: 24px;
  background-color: transparent;
  border: none;
  color: #b3a3a3;
  font-size: 1.2rem;
  cursor: pointer;
  border-radius: 80%;
  transition: all 0.3s ease;
  padding: 0;
  margin: 0;
  line-height: 1;
}

.clear-btn-search:hover {
  color: #333;
  background-color: #f5f5f5;
}


/* 使用教程样式 */
.usage-guide {
  margin-top: 2rem;              /* 设置顶部外边距为2rem，与上方元素保持距离 */
  padding: 1.5rem;               /* 设置内边距为1.5rem，内容与边框保持距离 */
  background-color: #fffbe6;     /* 设置背景颜色为浅黄色 */
  border-radius: 8px;            /* 设置圆角边框，半径为8px */
  border-left: 4px solid #ffd700; /* 设置左侧边框为4px宽的实线，颜色为金黄色 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 添加阴影效果，增强立体感 */
}

.usage-guide h3 {
  margin-top: 0;                 /* 设置顶部外边距为0，紧贴容器顶部 */
  margin-bottom: 1rem;           /* 设置底部外边距为1rem，与下方元素保持距离 */
  color: #333;                   /* 设置文字颜色为深灰色 */
  font-size: 1.2rem;             /* 设置字体大小为1.2rem */
  text-align: center;            /* 设置文字居中对齐 */
}

.usage-guide ul {
  padding-left: 0;               /* 设置左侧内边距为0，移除默认的列表缩进 */
  margin: 0;                     /* 设置外边距为0 */
  list-style: none;              /* 移除默认的列表符号 */
}

.usage-guide li {
  margin-bottom: 0.5rem;         /* 设置底部外边距为0.5rem，列表项之间保持距离 */
  color: #555;                   /* 设置文字颜色为中灰色 */
  line-height: 1.5;              /* 设置行高为1.5倍，提高可读性 */
  padding: 0.5rem 1rem;          /* 设置内边距，上下0.5rem，左右1rem */
  border-left: 2px solid #ffd700; /* 设置左侧边框为2px宽的实线，颜色为金黄色 */
  background-color: rgba(255, 215, 0, 0.1); /* 设置背景颜色为金黄色的半透明背景 */
}

.usage-guide li:last-child {
  margin-bottom: 0;              /* 最后一个列表项底部外边距为0，避免多余间距 */
}


/* 任务汇总信息样式 */
.task-summary {
  padding: 1rem 2rem;                    /* 设置内边距，上下1rem，左右2rem */
  background-color: #e3f2fd;             /* 设置背景色为浅蓝色 */
  border-radius: 8px;                    /* 设置圆角 */
  margin-bottom: 1rem;                   /* 设置下边距 */
  text-align: center;                    /* 文本居中对齐 */
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* 添加阴影效果 */
}

/* 任务汇总文本样式 */
.task-summary p {
  margin: 0;              /* 清除默认外边距 */
  color: #1976d2;         /* 设置文本颜色为深蓝色 */
  font-weight: 600;       /* 设置字体粗细 */
  font-size: 1.1rem;      /* 设置字体大小 */
}

/* 在样式部分添加以下内容 */

/* 加载更多提示 */
.loading-more {
  text-align: center;
  padding: 1rem;
  color: #666;
}

/* 没有更多数据提示 */
.no-more-data {
  text-align: center;
  padding: 1rem;
  color: #999;
  font-size: 0.9rem;
}

/* 确保任务列表容器可以滚动 */
.task-list-container {
  max-height: 850px; /* 或根据需要设置合适的高度 */
  overflow-y: auto;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 无任务提示 */
.no-tasks {
  text-align: center;
  color: #666;
  padding: 4rem 0;
}

/* 任务项 */
.task-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.5rem;
  margin-bottom: 1rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.task-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 视频信息 */
.video-info {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.video-cover {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}

.video-details {
  flex: 1;
}

.video-desc {
  font-size: 0.9rem;
  color: #333;
  margin-bottom: 0.5rem;
  line-height: 1.4;
}

.video-time,
.monitor-period {
  font-size: 0.8rem;
  color: #666;
  margin: 0.2rem 0;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 0.5rem;
}

.btn-view {
  background-color: #ff6b6b;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-view:hover {
  background-color: #e65a5a;
}

.btn-delete {
  background-color: #999;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-delete:hover {
  background-color: #777;
}

/* 图表弹窗 */
.chart-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  width: 80%;
  max-width: 1500px;
  max-height: 1000px;
  overflow-y: auto;
  padding: 2rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 
              0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid transparent;
  background: linear-gradient(white, white) padding-box,
              linear-gradient(135deg, #667eea 0%, #764ba2 100%) border-box;
  border-bottom: 2px solid transparent;
}

.modal-header h3 {
  margin: 0.3rem 0;
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.6;
}

.modal-header h3:first-child {
  font-size: 1.3rem;
  color: #667eea;
  font-weight: 700;
}

.close-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
  line-height: 1;
  padding: 0;
  margin-left: 1rem;
}

.close-btn:hover {
  transform: rotate(90deg) scale(1.1);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%);
}

.close-btn:active {
  transform: rotate(90deg) scale(0.95);
}

/* 表格弹窗 */
.table-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.table-modal-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 
              0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.table-container {
  overflow-x: auto;
  margin: 1rem 0;
}

.monitor-data-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.monitor-data-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.monitor-data-table th {
  padding: 1rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.95rem;
  border-bottom: 2px solid #e8eaec;
}

.monitor-data-table tbody tr {
  border-bottom: 1px solid #e8eaec;
  transition: background-color 0.2s ease;
}

.monitor-data-table tbody tr:hover {
  background-color: #f5f7fa;
}

.monitor-data-table td {
  padding: 0.8rem 1rem;
  text-align: center;
  font-size: 0.9rem;
  color: #333;
}

.monitor-data-table td:first-child {
  font-weight: 500;
  color: #667eea;
}

/* 作品链接样式 */
.video-link-cell {
  word-break: break-all;
  max-width: 300px;
}

.video-link {
  color: #667eea;
  text-decoration: none;
  font-size: 0.85rem;
}

.video-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

/* 查看表格按钮 */
.btn-view-table {
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  margin: 0 0.3rem;
}

.btn-view-table:hover {
  background-color: #66b1ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

.btn-view-table:active {
  transform: translateY(0);
}

/* 表格底部区域 */
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e8eaec;
}

.data-status-text {
  color: #999;
  font-size: 0.9rem;
}

/* 导出Excel按钮 */
.btn-export-excel {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.6rem 1.2rem;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(103, 194, 58, 0.3);
}

.btn-export-excel:hover {
  background: linear-gradient(135deg, #85ce61 0%, #67c23a 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(103, 194, 58, 0.4);
}

.btn-export-excel:active {
  transform: translateY(0);
}

/* 删除确认弹窗 */
.confirm-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.confirm-modal .modal-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  width: 50%;
  max-width: 400px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 
              0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.confirm-modal h3 {
  color: #ff6b6b;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.confirm-modal p {
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.btn-cancel {
  background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.5rem;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(149, 165, 166, 0.3);
}

.btn-cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(149, 165, 166, 0.4);
  background: linear-gradient(135deg, #7f8c8d 0%, #95a5a6 100%);
}

.btn-confirm {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.5rem;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
}

.btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 107, 107, 0.5);
  background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%);
}


/* 在 <style scoped> 中添加清空按钮样式 */
.url-input-container {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
}

.clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 80px;
  height: 24px;
  background-color: transparent;
  border: none;
  color: #b3a3a3;
  font-size: 1.2rem;
  cursor: pointer;
  border-radius: 80%;
  transition: all 0.3s ease;
  padding: 0;
  margin: 0;
  line-height: 1;
}

.clear-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #333;
}

/* 在 <style scoped> 中添加以下样式 */
.radio-group.disabled {
  opacity: 0.6;
}

.radio-option.disabled {
  color: #999;
  cursor: not-allowed;
}

.radio-input:disabled {
  background-color: #eee;
  border-color: #ccc;
  cursor: not-allowed;
}

.radio-text.disabled {
  color: #999;
}
/**
 * 视频信息内容区域样式
 */
.video-info-content {
  margin-top: 1rem;

}

.video-info-content h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.2rem;
  text-align: center;
}

/**
 * 视频信息区域样式
 */
.video-info-section {
  margin-top: 1.5rem;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.video-info-section h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.2rem;
  text-align: center;
}

.video-basic-info {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 1.5rem;
  justify-content: center; /* 添加这行实现居中显示 */
  align-items: center; /* 添加这行实现垂直居中 */
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center; /* 添加这行实现头像区域居中 */
}

.author-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.author-info .author-nickname {
  font-weight: 600;
  font-size: 1.1rem;
  margin: 0 0 0.25rem 0;
  color: #333;
}

.author-info .author-id {
  margin: 0;
  color: #666;
  font-size: 0.9rem;
}

.video-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.25rem;
}

.stat-value {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.video-desc {
  border-top: 1px solid #e1e5e9;
  padding-top: 1rem;
}

.video-description {
  margin: 0 0 0.5rem 0;
  color: #333;
  line-height: 1.5;
}

.video-time {
  margin: 0;
  color: #666;
  font-size: 0.9rem;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .video-basic-info {
    flex-direction: column;
    gap: 1rem;
  }

  .video-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .video-info-section {
    padding: 1rem;
  }
}

/**
 * 监控容器样式
 * 适配主界面内容区域，移除全屏布局
 */
.monitor-container {
  /* 使用 flex 布局 */
  display: flex;
  flex-direction: column;
  /* 设置背景色为透明，继承父容器背景 */
  background-color: transparent;
  /* 移除默认边距 */
  margin: 0;
  /* 设置字体 */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/**
 * 页面标题区域样式
 * 包含页面标题和副标题
 */
.page-header {
  /* 设置内边距 */
  padding: 1.5rem 1rem;
  /* 设置背景色为透明 */
  background-color: transparent;
  /* 移除阴影效果 */
  box-shadow: none;
  /* 设置文本对齐方式 */
  text-align: center;
}

/**
 * 页面标题样式
 */
.page-title {
  /* 设置字体大小 */
  font-size: 2.5rem;
  /* 设置字体粗细 */
  font-weight: 700;
  /* 设置颜色 */
  color: #333;
  /* 设置行高 */
  line-height: 1.2;
  /* 添加渐变效果 */
  background: linear-gradient(45deg, #ff6b6b, #ee5a24);
  /* 设置文本颜色为透明，使用背景渐变 */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/**
 * 页面副标题样式
 */
.page-subtitle {
  /* 设置字体大小 */
  font-size: 1.1rem;
  /* 设置颜色 */
  color: #666;
  /* 设置行高 */
  line-height: 1.5;
  /* 设置文字阴影 */
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  /* 设置最大宽度 */
  max-width: 600px;
  /* 设置自动换行 */
  word-wrap: break-word;
  /* 设置外边距 */
  margin: 1rem auto;
}

/**
 * 主要内容容器样式
 */
.main-content {
  /* 设置内边距 */
  padding: 0;
  /* 设置背景色为透明 */
  background-color: transparent;
  /* 移除圆角 */
  border-radius: 0;
  /* 移除阴影 */
  box-shadow: none;
  /* 设置宽度 */
  width: 100%;
  /* 设置最大宽度 */
  max-width: 100%;
  /* 设置水平居中 */
  margin: 0 auto;
  /* 设置内部布局 */
  flex: 1;
}

/**
 * Tab容器样式
 */
.tab-container {
  /* 设置内边距 */
  padding: 0;
  /* 设置背景色为透明 */
  background-color: transparent;
  /* 移除圆角 */
  border-radius: 0;
  /* 移除阴影 */
  box-shadow: none;
  /* 设置宽度 */
  width: 100%;
  /* 设置最大宽度 */
  max-width: 100%;
  /* 设置水平居中 */
  margin: 0 auto;
  /* 设置内部布局 */
  flex: 1;
}

/**
 * Tab导航样式
 */
.tab-nav {
  /* 设置显示方式为 flex */
  display: flex;
  /* 设置主轴对齐方式 */
  align-items: center;
  /* 设置交叉轴对齐方式 */
  justify-content: center;
  /* 设置间距 */
  gap: 2rem;
  /* 设置外边距 */
  margin-bottom: 2rem;
  /* 设置边界 */
  border-bottom: 1px solid #e1e5e9;
}

/**
 * Tab按钮样式
 */
.tab-btn {
  /* 设置背景色 */
  background-color: transparent;
  /* 设置颜色 */
  color: #666;
  /* 设置边框 */
  border: none;
  /* 设置圆角 */
  border-radius: 0;
  /* 设置内边距 */
  padding: 1rem 0;
  /* 设置字体大小 */
  font-size: 1rem;
  /* 设置字体粗细 */
  font-weight: 500;
  /* 设置光标 */
  cursor: pointer;
  /* 设置过渡效果 */
  transition: all 0.3s ease;
  /* 设置用户选择 */
  user-select: none;
  /* 设置位置 */
  position: relative;
}

/**
 * Tab按钮激活状态样式
 */
.tab-btn.active {
  /* 设置颜色 */
  color: #ff6b6b;
  /* 设置下划线 */
  border-bottom: 2px solid #ff6b6b;
  /* 设置阴影 */
  transform: translateY(-1px);
}

/**
 * Tab内容区域样式
 */
.tab-content {
  /* 设置最小高度 */
  min-height: 400px;
}

/**
 * Tab页面样式
 */
.tab-pane {
  /* 设置内边距 */
 /* padding: 2rem;*/
}

/**
 * 监控配置区域样式
 */
.monitor-config {
  /* 设置内边距 */
  padding: 1.5rem;
  /* 设置背景色 */
  background-color: #f8f9fa;
  /* 添加圆角 */
  border-radius: 8px;
  /* 添加阴影 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  /* 设置外边距 */
  margin-bottom: 1rem;
}

/**
 * 输入组样式
 * 包含输入框和按钮
 */
.input-group {
  /* 设置显示方式为 flex */
  display: flex;
  /* 设置主轴对齐方式 */
  align-items: center;
  /* 设置交叉轴对齐方式 */
  justify-content: center;
  /* 设置间距 */
  gap: 1rem;
  /* 设置外边距 */
  margin-bottom: 1.5rem;
}

/**
 * URL 输入框样式
 */
.url-input {
  /* 设置宽度 */
  flex: 1;
  /* 设置内边距 */
  padding: 1rem;
  /* 设置边框 */
  border: 2px solid #e1e5e9;
  /* 设置圆角 */
  border-radius: 8px;
  /* 设置字体大小 */
  font-size: 1rem;
  /* 设置过渡效果 */
  transition: all 0.3s ease;
  /* 设置占位符颜色 */
  color: #666;
}

/**
 * URL 输入框聚焦时样式
 */
.url-input:focus {
  /* 设置边框颜色 */
  border-color: #ff6b6b;
  /* 设置阴影 */
  box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);
  /* 移除默认轮廓 */
  outline: none;
}

/**
 * 提交按钮样式
 */
.submit-btn {
  /* 设置背景色 */
  background-color: #ff6b6b;
  /* 设置颜色 */
  color: white;
  /* 设置边框 */
  border: none;
  /* 设置圆角 */
  border-radius: 8px;
  /* 设置内边距 */
  padding: 1rem 2rem;
  /* 设置字体大小 */
  font-size: 1rem;
  /* 设置字体粗细 */
  font-weight: 600;
  /* 设置光标 */
  cursor: pointer;
  /* 设置过渡效果 */
  transition: all 0.3s ease;
  /* 设置用户选择 */
  user-select: none;
}

/**
 * 提交按钮悬停样式
 */
.submit-btn:hover:not(:disabled) {
  /* 设置背景色 */
  background-color: #e65a5a;
  /* 设置阴影 */
  transform: translateY(-1px);
}

/**
 * 提交按钮禁用样式
 */
.submit-btn:disabled {
  /* 设置背景色 */
  background-color: #ccc;
  /* 设置光标 */
  cursor: not-allowed;
  /* 设置阴影 */
  transform: none;
}

/**
 * 监控时长选项样式
 */
.duration-options {
  /* 设置内边距 */
  padding: 1rem;
  /* 设置背景色 */
  background-color: #fff;
  /* 设置圆角 */
  border-radius: 8px;
  /* 设置阴影 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  /* 设置外边距 */
  margin-top: 1rem;
}

/**
 * 监控时长标签样式
 */
.duration-label {
  /* 设置字体大小 */
  font-size: 1rem;
  /* 设置颜色 */
  color: #333;
  /* 设置字体粗细 */
  font-weight: 600;
  /* 设置外边距 */
  margin-bottom: 0.5rem;
  /* 设置显示方式 */
  display: block;
}

/**
 * 单选按钮组样式
 */
.radio-group {
  /* 设置显示方式 */
  display: flex;
  /* 设置主轴对齐方式 */
  justify-content: center;
  /* 设置交叉轴对齐方式 */
  align-items: center;
  /* 设置间距 */
  gap: 1rem;
  /* 设置弯曲 */
  flex-wrap: wrap;
}

/**
 * 单选按钮选项样式
 */
.radio-option {
  /* 设置显示方式 */
  display: flex;
  /* 设置主轴对齐方式 */
  align-items: center;
  /* 设置间距 */
  gap: 0.5rem;
  /* 设置字体大小 */
  font-size: 0.9rem;
  /* 设置颜色 */
  color: #666;
  /* 设置鼠标指针 */
  cursor: pointer;
  /* 设置过渡效果 */
  transition: all 0.3s ease;
}

/**
 * 单选按钮选项悬停样式
 */
.radio-option:hover {
  /* 设置颜色 */
  color: #333;
}

/**
 * 单选按钮输入样式
 */
.radio-input {
  /* 设置宽度 */
  width: 20px;
  /* 设置高度 */
  height: 20px;
  /* 设置圆角 */
  border-radius: 50%;
  /* 设置边框 */
  border: 2px solid #e1e5e9;
  /* 设置过渡效果 */
  transition: all 0.3s ease;
}

/**
 * 单选按钮输入选中样式
 */
.radio-input:checked {
  /* 设置背景色 */
  background-color: #ff6b6b;
  /* 设置边框颜色 */
  border-color: #ff6b6b;
}

/**
 * 单选按钮文本样式
 */
.radio-text {
  /* 设置字体大小 */
  font-size: 0.9rem;
  /* 设置颜色 */
  color: #666;
}

/**
 * 图表容器样式
 */
.chart-container {
  /* 设置高度 */
  height: 400px;
  /* 设置背景色 */
  background-color: #f8f9fa;
  /* 设置圆角 */
  border-radius: 12px;
  /* 设置阴影 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  /* 设置外边距 */
  margin-bottom: 1.5rem;
  /* 设置位置 */
  position: relative;
}

/**
 * 数据状态样式
 */
.data-status {
  /* 设置文本对齐方式 */
  text-align: center;
  /* 设置颜色 */
  color: #666;
  /* 设置字体大小 */
  font-size: 0.9rem;
  /* 设置外边距 */
  margin: 1rem 0;
}

/**
 * 结果摘要样式
 */
.result-summary {
  /* 设置内边距 */
  padding: 2rem;
  /* 设置背景色 */
  background-color: #f8f9fa;
  /* 设置圆角 */
  border-radius: 8px;
  /* 设置外边距 */
  margin-bottom: 2rem;
}

/**
 * 结果摘要标题样式
 */
.result-summary h3 {
  /* 设置字体大小 */
  font-size: 1.2rem;
  /* 设置颜色 */
  color: #333;
  /* 设置外边距 */
  margin-bottom: 1rem;
}

/**
 * 结果摘要列表样式
 */
.result-summary p {
  /* 设置字体大小 */
  font-size: 1rem;
  /* 设置颜色 */
  color: #666;
  /* 设置外边距 */
  margin: 0.5rem 0;
}

/**
 * 响应式设计
 * 针对移动端进行适配
 */
@media (max-width: 768px) {
  /**
   * 页面标题样式调整
   */
  .page-title {
    /* 调整字体大小 */
    font-size: 2rem;
  }

  /**
   * 页面副标题样式调整
   */
  .page-subtitle {
    /* 调整字体大小 */
    font-size: 1rem;
  }

  /**
   * 主要内容容器样式调整
   */
  .main-content {
    /* 调整内边距 */
    padding: 1rem;
    /* 调整圆角 */
    border-radius: 8px;
  }

  /**
   * 监控配置区域样式调整
   */
  .monitor-config {
    /* 调整内边距 */
    padding: 1rem;
    /* 调整圆角 */
    border-radius: 8px;
  }

  /**
   * 输入组样式调整
   */
  .input-group {
    /* 调整为垂直布局 */
    flex-direction: column;
    /* 调整间距 */
    gap: 0.5rem;
    /* 调整外边距 */
    margin-bottom: 1rem;
  }

  /**
   * URL 输入框样式调整
   */
  .url-input {
    /* 调整内边距 */
    padding: 0.75rem;
    /* 调整字体大小 */
    font-size: 0.9rem;
    /* 调整宽度 */
    width: 100%;
  }

  /**
   * 提交按钮样式调整
   */
  .submit-btn {
    /* 调整内边距 */
    padding: 0.75rem 1.5rem;
    /* 调整字体大小 */
    font-size: 0.9rem;
    /* 调整宽度 */
    width: 100%;
  }

  /**
   * 监控时长选项样式调整
   */
  .duration-options {
    /* 调整内边距 */
    padding: 0.75rem;
  }

  /**
   * 单选按钮组样式调整
   */
  .radio-group {
    /* 调整间距 */
    gap: 0.75rem;
  }

  /**
   * 单选按钮选项样式调整
   */
  .radio-option {
    /* 调整字体大小 */
    font-size: 0.8rem;
  }

  /**
   * 图表容器样式调整
   */
  .chart-container {
    /* 调整高度 */
    height: 300px;
  }

  /* 移动端监控结束任务列表优化 */
  .task-item {
    flex-direction: column;
    padding: 1rem;
  }

  .video-info {
    flex-direction: column;
    width: 100%;
  }

  .video-cover {
    width: 100%;
    max-width: 200px;
    height: auto;
    margin-bottom: 1rem;
  }

  .video-details {
    width: 100%;
  }

  /* 移动端操作按钮优化 */
  .action-buttons {
    width: 100%;
    margin-top: 1rem;
    gap: 0.5rem;
  }

  .action-buttons button {
    flex: 1;
    padding: 0.6rem 0.5rem;
    font-size: 0.85rem;
    min-width: 0;
  }

  .btn-view,
  .btn-view-table,
  .btn-delete {
    padding: 0.6rem 0.5rem;
    font-size: 0.85rem;
    flex: 1;
  }

  /* 移动端表格弹窗优化 */
  .table-modal-content {
    width: 95%;
    max-width: 95%;
    padding: 1rem;
  }

  .table-modal-content .modal-header {
    flex-direction: column;
    gap: 0.5rem;
  }

  .table-modal-content .modal-header h3 {
    font-size: 0.9rem;
    text-align: center;
  }

  .monitor-data-table {
    font-size: 0.75rem;
  }

  .monitor-data-table th {
    padding: 0.5rem 0.3rem;
    font-size: 0.7rem;
  }

  .monitor-data-table td {
    padding: 0.5rem 0.3rem;
    font-size: 0.7rem;
  }

  .video-link-cell {
    max-width: 80px;
  }

  .video-link {
    font-size: 0.65rem;
  }

  .table-footer {
    flex-direction: column;
    gap: 0.5rem;
  }

  .btn-export-excel {
    width: 100%;
    padding: 0.5rem;
    font-size: 0.85rem;
  }

  .data-status-text {
    font-size: 0.75rem;
  }

  /* 移动端图表弹窗优化 */
  .chart-modal .modal-content {
    width: 95%;
    max-width: 95%;
    padding: 1rem;
    max-height: 90vh;
  }

  .chart-modal .modal-header {
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
  }

  .chart-modal .modal-header h3 {
    font-size: 0.85rem;
    text-align: center;
    word-break: break-all;
  }

  .chart-modal .chart-container {
    height: 250px;
    margin-top: 1rem;
  }

  .chart-modal .data-status {
    margin-top: 0.5rem;
  }

  .chart-modal .data-status span {
    font-size: 0.75rem;
  }

  /* 移动端搜索输入框优化 */
  .search-input {
    width: 100%;
    box-sizing: border-box;
  }

  .search-container {
    width: 100%;
  }

  /* 移动端监控输入框优化 */
  .url-input-container {
    width: 100%;
    flex: none;
  }

  .url-input {
    width: 100%;
    box-sizing: border-box;
  }

  .input-group {
    width: 100%;
  }
}

/**
 * 暗色主题支持
 */
@media (prefers-color-scheme: dark) {
  /**
   * 监控容器样式调整
   */
  .monitor-container {
    /* 调整背景色 */
    background-color: #1a1a1a;
  }

  /**
   * 页面标题区域样式调整
   */
  .page-header {
    /* 调整背景色 */
    background-color: #2d2d2d;
  }

  /**
   * 主要内容容器样式调整
   */
  .main-content {
    /* 调整背景色 */
    background-color: #2d2d2d;
  }

  /**
   * 监控配置区域样式调整
   */
  .monitor-config {
    /* 调整背景色 */
    background-color: #3a3a3a;
  }

  /**
   * URL 输入框样式调整
   */
  .url-input {
    /* 调整边框颜色 */
    border-color: #4a4a4a;
    /* 调整颜色 */
    color: #eee;
    /* 调整背景色 */
    background-color: #2d2d2d;
  }

  /**
   * URL 输入框聚焦时样式调整
   */
  .url-input:focus {
    /* 调整边框颜色 */
    border-color: #ff6b6b;
    /* 调整阴影 */
    box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);
  }

  /**
   * 提交按钮样式调整
   */
  .submit-btn {
    /* 调整背景色 */
    background-color: #ff6b6b;
  }

  /**
   * 提交按钮悬停样式调整
   */
  .submit-btn:hover:not(:disabled) {
    /* 调整背景色 */
    background-color: #e65a5a;
  }

  /**
   * 监控时长选项样式调整
   */
  .duration-options {
    /* 调整背景色 */
    background-color: #3a3a3a;
  }

  /**
   * 单选按钮输入样式调整
   */
  .radio-input {
    /* 调整边框颜色 */
    border-color: #4a4a4a;
  }

  /**
   * 单选按钮输入选中样式调整
   */
  .radio-input:checked {
    /* 调整背景色 */
    background-color: #ff6b6b;
    /* 调整边框颜色 */
    border-color: #ff6b6b;
  }

  /**
   * 单选按钮文本样式调整
   */
  .radio-text {
    /* 调整颜色 */
    color: #eee;
  }

  /**
   * 图表容器样式调整
   */
  .chart-container {
    /* 调整背景色 */
    background-color: #3a3a3a;
  }

  /**
   * 数据状态样式调整
   */
  .data-status {
    /* 调整颜色 */
    color: #aaa;
  }
}

/**
 * 主题切换支持 - 星空主题（深色）
 */
.theme-starry .page-title {
  background: linear-gradient(45deg, #64ffda, #00bcd4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.theme-starry .page-subtitle {
  color: #a0aec0;
}

.theme-starry .monitor-config {
  background-color: #1a1a2e;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.theme-starry .tab-nav {
  border-bottom-color: #2a2a3e;
}

.theme-starry .tab-btn {
  color: #a0aec0;
}

.theme-starry .tab-btn.active {
  color: #64ffda;
  border-bottom-color: #64ffda;
}

.theme-starry .url-input {
  background-color: #0f0f1a;
  border-color: #2a2a3e;
  color: #e2e8f0;
}

.theme-starry .url-input:focus {
  border-color: #64ffda;
  box-shadow: 0 0 0 3px rgba(100, 255, 218, 0.2);
}

.theme-starry .submit-btn {
  background-color: #64ffda;
  color: #1a1a2e;
}

.theme-starry .submit-btn:hover:not(:disabled) {
  background-color: #00bcd4;
}

.theme-starry .submit-btn:disabled {
  background-color: #2a2a3e;
  color: #718096;
}

.theme-starry .video-info-section {
  background-color: #1a1a2e;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.theme-starry .video-info-section h3 {
  color: #e2e8f0;
}

.theme-starry .duration-options {
  background-color: #16213e;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.theme-starry .duration-label {
  color: #e2e8f0;
}

.theme-starry .radio-text {
  color: #a0aec0;
}

.theme-starry .usage-guide {
  background-color: #16213e;
  border-left-color: #64ffda;
}

.theme-starry .usage-guide h3 {
  color: #e2e8f0;
}

.theme-starry .usage-guide li {
  color: #a0aec0;
  border-left-color: #64ffda;
  background-color: rgba(100, 255, 218, 0.1);
}

.theme-starry .task-summary {
  background-color: #16213e;
}

.theme-starry .task-summary p {
  color: #64ffda;
}

.theme-starry .task-list-container {
  background-color: #1a1a2e;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.theme-starry .task-item {
  background-color: #16213e;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.theme-starry .task-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

.theme-starry .video-desc {
  color: #e2e8f0;
}

.theme-starry .video-time,
.theme-starry .monitor-period {
  color: #a0aec0;
}

.theme-starry .btn-view {
  background-color: #64ffda;
  color: #1a1a2e;
}

.theme-starry .btn-view:hover {
  background-color: #00bcd4;
}

.theme-starry .btn-view-table {
  background-color: #64ffda;
  color: #1a1a2e;
}

.theme-starry .btn-view-table:hover {
  background-color: #00bcd4;
}

.theme-starry .monitor-data-table thead {
  background: linear-gradient(135deg, #64ffda 0%, #00bcd4 100%);
  color: #1a1a2e;
}

.theme-starry .monitor-data-table td:first-child {
  color: #64ffda;
}

.theme-starry .table-modal-content {
  background-color: #1a1a2e;
}

.theme-starry .monitor-data-table {
  background-color: #16213e;
  color: #e2e8f0;
}

.theme-starry .monitor-data-table th {
  color: #1a1a2e;
}

.theme-starry .monitor-data-table td {
  color: #e2e8f0;
}

.theme-starry .monitor-data-table tbody tr {
  border-bottom-color: #2d3748;
}

.theme-starry .monitor-data-table tbody tr:hover {
  background-color: #16213e;
}

.theme-starry .table-footer {
  border-top-color: #2d3748;
}

.theme-starry .btn-export-excel {
  background: linear-gradient(135deg, #64ffda 0%, #00bcd4 100%);
  color: #1a1a2e;
}

.theme-starry .btn-export-excel:hover {
  background: linear-gradient(135deg, #00bcd4 0%, #64ffda 100%);
}

.theme-starry .data-status-text {
  color: #a0aec0;
}

.theme-starry .btn-delete {
  background-color: #4a5568;
}

.theme-starry .btn-delete:hover {
  background-color: #718096;
}

.theme-starry .search-input {
  background-color: #0f0f1a;
  border-color: #2a2a3e;
  color: #e2e8f0;
}

.theme-starry .search-input:focus {
  border-color: #64ffda;
  box-shadow: 0 0 0 3px rgba(100, 255, 218, 0.2);
}

.theme-starry .submit-btn-search {
  background-color: #64ffda;
  color: #1a1a2e;
}

.theme-starry .submit-btn-search:hover {
  background-color: #00bcd4;
}

.theme-starry .chart-container {
  background-color: #1a1a2e;
}

.theme-starry .data-status {
  color: #a0aec0;
}

/**
 * 主题切换支持 - 蓝色主题
 */
.theme-blue .page-title {
  background: linear-gradient(45deg, #2196F3, #1976D2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.theme-blue .tab-btn.active {
  color: #2196F3;
  border-bottom-color: #2196F3;
}

.theme-blue .url-input:focus {
  border-color: #2196F3;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.2);
}

.theme-blue .submit-btn {
  background-color: #2196F3;
}

.theme-blue .submit-btn:hover:not(:disabled) {
  background-color: #1976D2;
}

.theme-blue .task-summary {
  background-color: #E3F2FD;
}

.theme-blue .task-summary p {
  color: #1976D2;
}

.theme-blue .btn-view {
  background-color: #2196F3;
}

.theme-blue .btn-view:hover {
  background-color: #1976D2;
}

.theme-blue .btn-view-table {
  background-color: #2196F3;
}

.theme-blue .btn-view-table:hover {
  background-color: #1976D2;
}

.theme-blue .monitor-data-table thead {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
}

.theme-blue .monitor-data-table td:first-child {
  color: #2196F3;
}

.theme-blue .table-modal-content {
  background-color: #fff;
}

.theme-blue .monitor-data-table tbody tr:hover {
  background-color: #E3F2FD;
}

.theme-blue .btn-export-excel {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
}

.theme-blue .btn-export-excel:hover {
  background: linear-gradient(135deg, #1976D2 0%, #2196F3 100%);
}

/**
 * 主题切换支持 - 紫色主题
 */
.theme-purple .page-title {
  background: linear-gradient(45deg, #9C27B0, #7B1FA2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.theme-purple .tab-btn.active {
  color: #9C27B0;
  border-bottom-color: #9C27B0;
}

.theme-purple .url-input:focus {
  border-color: #9C27B0;
  box-shadow: 0 0 0 3px rgba(156, 39, 176, 0.2);
}

.theme-purple .submit-btn {
  background-color: #9C27B0;
}

.theme-purple .submit-btn:hover:not(:disabled) {
  background-color: #7B1FA2;
}

.theme-purple .task-summary {
  background-color: #F3E5F5;
}

.theme-purple .task-summary p {
  color: #7B1FA2;
}

.theme-purple .btn-view {
  background-color: #9C27B0;
}

.theme-purple .btn-view:hover {
  background-color: #7B1FA2;
}

.theme-purple .btn-view-table {
  background-color: #9C27B0;
}

.theme-purple .btn-view-table:hover {
  background-color: #7B1FA2;
}

.theme-purple .monitor-data-table thead {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
}

.theme-purple .monitor-data-table td:first-child {
  color: #9C27B0;
}

.theme-purple .table-modal-content {
  background-color: #fff;
}

.theme-purple .monitor-data-table tbody tr:hover {
  background-color: #F3E5F5;
}

.theme-purple .btn-export-excel {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
}

.theme-purple .btn-export-excel:hover {
  background: linear-gradient(135deg, #7B1FA2 0%, #9C27B0 100%);
}

/**
 * 主题切换支持 - 绿色主题
 */
.theme-green .page-title {
  background: linear-gradient(45deg, #4CAF50, #388E3C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.theme-green .tab-btn.active {
  color: #4CAF50;
  border-bottom-color: #4CAF50;
}

.theme-green .url-input:focus {
  border-color: #4CAF50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.2);
}

.theme-green .submit-btn {
  background-color: #4CAF50;
}

.theme-green .submit-btn:hover:not(:disabled) {
  background-color: #388E3C;
}

.theme-green .task-summary {
  background-color: #E8F5E9;
}

.theme-green .task-summary p {
  color: #388E3C;
}

.theme-green .btn-view {
  background-color: #4CAF50;
}

.theme-green .btn-view:hover {
  background-color: #388E3C;
}

/**
 * 主题切换支持 - 红色主题
 */
.theme-red .page-title {
  background: linear-gradient(45deg, #F44336, #D32F2F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.theme-red .tab-btn.active {
  color: #F44336;
  border-bottom-color: #F44336;
}

.theme-red .url-input:focus {
  border-color: #F44336;
  box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.2);
}

.theme-red .submit-btn {
  background-color: #F44336;
}

.theme-red .submit-btn:hover:not(:disabled) {
  background-color: #D32F2F;
}

.theme-red .task-summary {
  background-color: #FFEBEE;
}

.theme-red .task-summary p {
  color: #D32F2F;
}

.theme-red .btn-view {
  background-color: #F44336;
}

.theme-red .btn-view:hover {
  background-color: #D32F2F;
}

/**
 * 主题切换支持 - 橙色主题
 */
.theme-orange .page-title {
  background: linear-gradient(45deg, #FF9800, #F57C00);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.theme-orange .tab-btn.active {
  color: #FF9800;
  border-bottom-color: #FF9800;
}

.theme-orange .url-input:focus {
  border-color: #FF9800;
  box-shadow: 0 0 0 3px rgba(255, 152, 0, 0.2);
}

.theme-orange .submit-btn {
  background-color: #FF9800;
}

.theme-orange .submit-btn:hover:not(:disabled) {
  background-color: #F57C00;
}

.theme-orange .task-summary {
  background-color: #FFF3E0;
}

.theme-orange .task-summary p {
  color: #F57C00;
}

.theme-orange .btn-view {
  background-color: #FF9800;
}

.theme-orange .btn-view:hover {
  background-color: #F57C00;
}

/**
 * 主题切换器样式
 */
.theme-switcher {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

.theme-switcher .ivu-select {
  border-radius: 8px;
}

/**
 * 经典模式样式
 */
.theme-default .page-header {
  background: #ffffff;
  border-bottom: 2px solid #e8e8e8;
}

.theme-default .page-title {
  color: #1a1a1a !important;
  -webkit-text-fill-color: #1a1a1a !important;
}

.theme-default .page-subtitle {
  color: #666666;
}

.theme-default .tab-btn {
  color: #333333;
  border-bottom-color: transparent;
}

.theme-default .tab-btn.active {
  color: #1890ff !important;
  border-bottom-color: #1890ff !important;
}

.theme-default .url-input {
  background: #f9f9f9;
  border: 2px solid #d9d9d9;
  color: #1a1a1a;
}

.theme-default .url-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.2);
}

.theme-default .submit-btn {
  background-color: #1890ff;
  color: #ffffff;
}

.theme-default .submit-btn:hover:not(:disabled) {
  background-color: #40a9ff;
}

.theme-default .task-summary {
  background-color: #f0f0f0;
}

.theme-default .task-summary p {
  color: #333333;
}

.theme-default .btn-view {
  background-color: #1890ff;
  color: #ffffff;
}

.theme-default .btn-view:hover {
  background-color: #40a9ff;
}

.theme-default .btn-delete {
  background-color: #ff4d4f;
  color: #ffffff;
}

.theme-default .btn-delete:hover {
  background-color: #ff7875;
}
</style>